import React, { useState, useEffect, useRef } from "react";
import * as echarts from 'echarts';
import DashboardMainContainer from "../common/Containers/DashboardMainContainer";
import { AdminPanelTitle, AdminMetric } from '../../sections/AdminDashboard/shared/adminUx';
import { AdminWidgetHeader, AdminWidgetPeriodFilter, AdminWidgetMetricDelta } from './AdminWidgetChrome';
import { dashboardChartTooltipAxisFormatter } from './dashboardChartTooltip';

const FollowersWidget = () => {
  const [followersFilterPeriod, setFollowersFilterPeriod] = useState('7 Days');
  const followersChartRef = useRef(null);

  // Followers data for different periods
  const followersData = {
    '7 Days': {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      data: [1161, 2180, 2800, 5250, 3300, 9320, 12345],
      current: 12345,
      change: 184
    },
    '14 Days': {
      labels: ['Week 1', 'Week 2'],
      data: [6000, 12345],
      current: 12345,
      change: 6345
    },
    '30 Days': {
      labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
      data: [8000, 9500, 11000, 12345],
      current: 12345,
      change: 2345
    },
    '90 Days': {
      labels: ['Month 1', 'Month 2', 'Month 3'],
      data: [6000, 9000, 12345],
      current: 12345,
      change: 3345
    },
    '1 Year': {
      labels: ['Q1', 'Q2', 'Q3', 'Q4'],
      data: [4000, 7000, 10000, 12345],
      current: 12345,
      change: 2345
    }
  };

  // Initialize chart
  useEffect(() => {
    if (followersChartRef.current) {
      const chart = echarts.init(followersChartRef.current);
      const option = {
        tooltip: { 
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderColor: '#e5e7eb',
          borderWidth: 1,
          textStyle: { color: '#374151' },
          renderMode: 'html',
          formatter: (params) => dashboardChartTooltipAxisFormatter(params, 'Followers'),
        },
        grid: { 
          top: 0, 
          right: 0, 
          bottom: 0, 
          left: 0,
          containLabel: false
        },
        xAxis: {
          type: 'category',
          data: followersData[followersFilterPeriod].labels,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { show: false },
          boundaryGap: false
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { show: false },
          splitLine: { show: false },
          boundaryGap: false
        },
        series: [{
          name: 'Followers',
          data: followersData[followersFilterPeriod].data,
          type: 'line',
          lineStyle: { 
            color: '#2E00FF', 
            width: 2 
          },
          areaStyle: { 
            color: { 
              type: 'linear', 
              x: 0, y: 0, x2: 0, y2: 1, 
              colorStops: [
                { offset: 0, color: 'rgba(123, 98, 217, 0.4)' }, 
              ] 
            } 
          },
          symbol: 'none',
          symbolSize: 0
        }]
      };
      chart.setOption(option);
      
      // Handle resize
      const handleResize = () => {
        chart.resize();
      };
      window.addEventListener('resize', handleResize);
      
      // Cleanup
      return () => {
        window.removeEventListener('resize', handleResize);
        chart.dispose();
      };
    }
  }, [followersFilterPeriod]);

  return (
    <DashboardMainContainer className="masonry-item w-[270px] h-[267px] rounded-lg flex flex-col">
      <AdminWidgetHeader title="Followers">
        <AdminWidgetPeriodFilter
          period={followersFilterPeriod}
          onPeriodChange={setFollowersFilterPeriod}
        />
      </AdminWidgetHeader>
      <div className="flex-1 p-4 text-center">
        <div className="mt-4 mb-6">
          <AdminMetric size="large" className="text-offblack tabular-nums">
            {followersData[followersFilterPeriod].current.toLocaleString()}
          </AdminMetric>
          <div className="flex items-center justify-center gap-1 mt-2 mb-5">
            <AdminPanelTitle className="text-offblack mr-2">Followers</AdminPanelTitle>
            <AdminWidgetMetricDelta
              value={followersData[followersFilterPeriod].change}
              trend="up"
            />
          </div>
        </div>
        {/* Chart */}
        <div className="h-20 w-full" ref={followersChartRef}></div>
      </div>
    </DashboardMainContainer>
  );
};

export default FollowersWidget;
